import { Link } from "react-router-dom";
import { catLabel, fmtDate } from "../lib/api";

export const Meta = ({ a, light = false }) => (
  <div className={`kicker flex flex-wrap items-center gap-x-3 gap-y-1 ${light ? "text-cream/80" : "text-ink/70"}`}>
    <span className={light ? "text-blush" : "text-rose"}>{catLabel(a.category)}</span>
    <span>{fmtDate(a.published)}</span>
    <span>{a.read_time} min</span>
  </div>
);

export const OverlayCard = ({ a, className = "", size = "md", testId }) => (
  <Link to={`/article/${a.slug}`} className={`flip group img-zoom relative block overflow-hidden bg-ink min-h-[380px] ${className}`} data-testid={testId}>
    <img src={a.cover} alt={a.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/25 to-transparent" />
    <div className="absolute inset-0 bg-ink opacity-0 group-hover:opacity-20 transition-opacity duration-500" />
    <div className="absolute inset-x-0 bottom-0 p-5 sm:p-7">
      <Meta a={a} light />
      <h3 className={`display text-cream mt-3 ${size === "lg" ? "text-5xl sm:text-6xl lg:text-7xl" : "text-3xl sm:text-4xl"}`}>{a.title}</h3>
      {size === "lg" && <p className="font-serif italic text-xl text-cream/90 mt-3 max-w-xl">{a.dek}</p>}
    </div>
  </Link>
);

export const StackCard = ({ a, ratio = "aspect-[4/5]", testId, showDek = true }) => (
  <Link to={`/article/${a.slug}`} className="group block" data-testid={testId}>
    <div className={`img-zoom overflow-hidden bg-blush ${ratio}`}>
      <img src={a.cover} alt={a.title} loading="lazy" className="h-full w-full object-cover" />
    </div>
    <div className="mt-4">
      <Meta a={a} />
      <h3 className="display text-3xl mt-2 group-hover:text-rose transition-colors">{a.title}</h3>
      {showDek && <p className="font-serif italic text-lg text-ink/75 mt-1.5 leading-snug">{a.dek}</p>}
    </div>
  </Link>
);

export const RowCard = ({ a, index, testId, light = false }) => (
  <Link to={`/article/${a.slug}`} className={`group grid grid-cols-[96px_1fr] sm:grid-cols-[150px_1fr] gap-4 sm:gap-6 py-5 border-t ${light ? "border-cream/20" : "border-ink/15"}`} data-testid={testId}>
    <div className="img-zoom overflow-hidden aspect-square bg-blush relative">
      <img src={a.cover} alt={a.title} loading="lazy" className="h-full w-full object-cover" />
      {index !== undefined && <span className="absolute top-1 left-1 kicker bg-cream text-ink px-1.5">{String(index).padStart(2, "0")}</span>}
    </div>
    <div className="self-center">
      <Meta a={a} light={light} />
      <h3 className={`display text-2xl sm:text-3xl mt-1.5 transition-colors ${light ? "text-cream group-hover:text-hot" : "group-hover:text-rose"}`}>{a.title}</h3>
      <p className={`hidden sm:block font-serif italic text-lg mt-1 ${light ? "text-cream/75" : "text-ink/70"}`}>{a.dek}</p>
    </div>
  </Link>
);
